import { MantineColor } from '@mantine/core';
import { ExecutionState } from '@/utils/api/fab.types';

export const executionStateColor: Partial<Record<ExecutionState, MantineColor>> = {
  [ExecutionState.Input]: 'teal.9',
  [ExecutionState.Output]: 'blue.9',
  [ExecutionState.CardProg]: 'lime.9',
  [ExecutionState.Qa]: 'cyan.9',
};
